module.exports = __webpack_public_path__ + "img/banner_youtube.9cc94878.jpeg";